/**
 * @generated SignedSource<<0b1c37467305a94a96a8dc0733ad4fcb>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ListCurrentViewFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HeaderCurrentViewFragment" | "SearchCurrentViewFragment">;
  readonly " $fragmentType": "ListCurrentViewFragment";
};
export type ListCurrentViewFragment$key = {
  readonly " $data"?: ListCurrentViewFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListCurrentViewFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListCurrentViewFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SearchCurrentViewFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderCurrentViewFragment"
    }
  ],
  "type": "Shortcutable",
  "abstractKey": "__isShortcutable"
};

(node as any).hash = "05ee3fdaa319a2a74e5b5a03a864a22f";

export default node;
